export default __webpack_public_path__ + "static/media/punches.847a6ee0.svg";